(() => {
  if (window.__fdhSpecialOrderLoaded) return;
  window.__fdhSpecialOrderLoaded = true;

  const SPECIAL_PROPERTY_NAME = 'properties[Special Order]';
  const RETURN_PROPERTY_NAME = 'properties[Return Policy]';
  const STYLE_ID = 'fdh-special-order-styles';

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .product.js-product.fdh-special-order-active .backorder,
      .product.js-product.fdh-special-order-active product-inventory,
      .product.js-product.fdh-special-order-active .product-info__dynamic-checkout-button {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  function upsertHiddenProperty(form, selector, name, value) {
    let input = form.querySelector(selector);
    if (!value) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function syncSpecialOrderState(productRoot, variantId) {
    if (!productRoot) return;

    const escapedId = CSS.escape(String(variantId || ''));
    const specialNotice = productRoot.querySelector(
      `.fdh-special-order-notice[data-fdh-special-order-variant-id="${escapedId}"]`
    );
    const nonReturnableNotice = productRoot.querySelector(
      `.fdh-nonreturnable-notice[data-fdh-nonreturnable-variant-id="${escapedId}"]`
    );

    const isSpecialOrder = Boolean(specialNotice);
    const isNonReturnable =
      Boolean(nonReturnableNotice) ||
      specialNotice?.dataset.fdhReturnPolicy === 'non-returnable';

    productRoot.classList.toggle('fdh-special-order-active', isSpecialOrder);

    const form = productRoot.querySelector('form.js-product-form-main');
    if (!form) return;

    let specialValue = '';
    if (isSpecialOrder) {
      specialValue = isNonReturnable
        ? 'Ships in 2–4 Weeks – Non-Returnable. Cancellation or changes may not be possible.'
        : 'Ships in 2–4 Weeks – Returnable with 50% restocking fee. Cancellation or changes may not be possible.';
    }

    let returnValue = '';
    if (isNonReturnable) {
      returnValue = 'Non-Returnable';
    } else if (isSpecialOrder) {
      returnValue = 'Returnable – 50% restocking fee';
    }

    upsertHiddenProperty(
      form,
      'input[data-fdh-special-order-property]',
      SPECIAL_PROPERTY_NAME,
      specialValue
    );
    const specialInput = form.querySelector('input[name="properties[Special Order]"]');
    if (specialInput) specialInput.dataset.fdhSpecialOrderProperty = 'true';

    upsertHiddenProperty(
      form,
      'input[data-fdh-return-policy-property]',
      RETURN_PROPERTY_NAME,
      returnValue
    );
    const returnInput = form.querySelector('input[name="properties[Return Policy]"]');
    if (returnInput) returnInput.dataset.fdhReturnPolicyProperty = 'true';
  }

  function initProduct(productRoot) {
    if (!productRoot || productRoot.dataset.fdhSpecialOrderInitialized === 'true') return;
    productRoot.dataset.fdhSpecialOrderInitialized = 'true';

    const variantPicker = productRoot.querySelector('variant-picker');
    const variantLabel = productRoot.querySelector('variant-label[data-current-variant-id]');
    const form = productRoot.querySelector('form.js-product-form-main');
    const initialVariantId =
      form?.querySelector('input[name="id"]')?.value ||
      variantLabel?.dataset.currentVariantId ||
      '';

    syncSpecialOrderState(productRoot, initialVariantId);

    if (variantPicker) {
      variantPicker.addEventListener('on:variant:change', (event) => {
        syncSpecialOrderState(productRoot, event.detail?.variant?.id || '');
      });
    }
  }

  function initAll() {
    ensureStyles();
    document.querySelectorAll('.product.js-product').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();